import { REDIRECTEDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const useRedirectPqrListActions = (id: string | number) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${REDIRECTEDIT}/${id}`, '_blank');
    };

    return {
        handleEdit,
    };
};
